import React, { useEffect, useRef, useState } from "react";
import tempJson from "../../../json/fallbackglobalvariables.json";
import Storage from "../../../utility/features/helpers/storageHelper";
import { IsLoggedIn } from "../../../utility/features/helpers/authHelper";
import { useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import Dropdown from "../../ui/dropdown";
import { encryptData } from "../../../utility/utils/hashing";
import store from "../../../reduxStore/store";
import Globals, { URLS } from "../../../utility/constants/appConstants";
import {
  formatDateDelmtrYYYYMMDD,
  formatDateYYYYMMDD,
  formatDateMMDDYYYY,
} from "../../../utility/utils/dateUtil";
import { amountFormatter } from "../../../utility/utils/formatter";
import BaseClient from "../../../utility/apiClients/base/baseClient";
import ecommEndpoints from "../../../utility/features/endPoints/ecommEndpoints";
import DocumentWrapper from "./documentWrapper";
import styles from "../../../styles/myAccount/myDocuments.module.scss";
import { MY_DOCUMENTS } from "./myDocumentConstatnts";
import customerSummaryClient from "../../../utility/apiClients/customer/customerSummaryClient";
import { setCustomerInfo } from "../../../reduxStore/login/loginSlice";
import Loader from "../../loader";
import $ from "jquery";
import ErrorBlock from "../../errorMessage";
import missionStatusClient from "../../../utility/apiClients/user/missionStatusClient";
const timeout = JSON.parse(process.env.REACT_APP_ECOMM_TIMEOUT_SEC) * 1000;

//map body to request body as per API
const mapRequest = (customerNumber, serviceAddress) => {

  const customerInfo = store.getState().login.customerInfo;
  const selAdd = store.getState().accountSummary.selectedServiceAddress;

  let cusNumber = null;
  if(selAdd !== null && serviceAddress === undefined){
    [serviceAddress, cusNumber] = selAdd.split(" | ");
  }

  if(serviceAddress === undefined){
    serviceAddress = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[0] || "";
  }

  let addressID = null;
  if(customerInfo && customerInfo.length > 0){
    for(const customer of customerInfo) {
      if(customer.CustomerNumber === customerNumber){

        if(customer.ServiceAddresses && customer.ServiceAddresses.length > 0){
          for(const srvcAddress of customer.ServiceAddresses) {
            if(srvcAddress.address === serviceAddress){
              addressID = srvcAddress.addressId;
              break;
            }
          }
        }
        if(addressID !== null){
          break;
        }
      }
    }
  }

  customerNumber =
    typeof customerNumber === "undefined"
      ? Storage.customerNumber()
      : customerNumber;
  serviceAddress =
    typeof serviceAddress === "undefined"
      ? Storage.serviceAddress()
      : serviceAddress;

  customerNumber =
    process.env.REACT_APP_CUSLOC_ENABLE === "true"
      ? `${customerNumber}__customervalue${Date.now()}`
      : customerNumber;

  return {
    CustomerNumber: encryptData(customerNumber, "customerNumber"),
    svcAddressLine1: serviceAddress,
    addressID: addressID
  };
};

const MyDocuments = () => {
  const labels = tempJson.acc;
  let headers = [];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedYear, setSelectedYear] = useState("");
  const [years, setYears] = useState([]);
  const [unauthorizeResponse, setUnauthorizeResponse] = useState(false);
  const [dataServices, setDataServices] = useState(null);
  const [dataInvoices, setDataInvoices] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  
  const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);
  
  const custNumbers = JSON.parse(localStorage.getItem("customerNumbers")) || [];
  const [custNo, setCustNo] = useState(custNumbers[0]);

  try {
    headers = JSON.parse(labels?.commonHeaders);
  } catch (e) { }

  const { post } = BaseClient();

  const missionStatusCheck = async () => {
    try {
      const missionStatus = await missionStatusClient();
      return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
    } catch (err) {
      console.error("Error checking mission status api:", err);
      return false;
    }
  };

  const customerSummaryInfo = useSelector((state) => state.login.customerInfo);
    
  const [customerSummary, setCustomerSummary] = useState(customerSummaryInfo);
  const selectedServiceAddress = useSelector(
    (state) => state.accountSummary.selectedServiceAddress
  );
  const bypassCache = store.getState().accountSummary.bypassAccountDetailsCache;

  const newTimeStampValue =
    new Date().getTime().toString() + Math.floor(Math.random() * 1000000);

  const getCustomerSummary = async (custNum) => {
    if (custNum === "") return;

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      return;
    }

    try {
      const customerSummary = await customerSummaryClient(custNum);

      if (customerSummary?.status && customerSummary?.status === 401 ) {
          console.log("Unauthorized access - 401");
          localStorage.clear();
          navigate("/login", { replace: true });
          return;
      }
      
      if (
        customerSummary?.data === null ||
        customerSummary?.data === undefined
      ) {
        setErrMsg("Some error occurred.");
        return;
      }

      dispatch(setCustomerInfo(customerSummary?.data));
    } catch (err) {
      setErrMsg("Some error occurred.");
    }
  };

  const fetchAccountDetails = async (
    customerNumber,
    serviceAddress,
    bypassCacheHeaderValue, 
  ) => {

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const requestBody = mapRequest(customerNumber, serviceAddress);
    let addrID = "";
    if(document.getElementById("serviceAddressSelect")){
      addrID = document.getElementById("serviceAddressSelect")?.value?.split(" | ")?.[2] || "";
      
      if(addrID !== "" && addrID !== null && addrID !== undefined && addrID !== "undefined")
        requestBody.addressID = parseInt(addrID);
    }
    const response = await post(
      process.env.REACT_APP_ECOMM_URL + ecommEndpoints.getAccountDetails(),
      requestBody,
      { timeout, headers: { "bypass-cache": bypassCacheHeaderValue } },
      true
    );
    
    if(response.status === 500){
      setErrMsg("Some Error Occured.")
      setIsLoading(false);
      return;
    } else if (response?.status === 424) {
      setErrMsg("Some Error Occured.")
      setIsLoading(false);
      return;
    }  
    
    if (response && !(response.error)) {
      const data = response.data;

      const encryptedCustNo = customerNumber ? encryptData(`${customerNumber}__customervalue${Date.now()}`, "customerNumber") : '';
      const formatedCustomerNumber = encryptedCustNo.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

      const salesagr = data?.SalesAgreements;
      const invoiceYears = data.InvoiceYears.reverse();
      const dataInvoices = salesagr.reduce((acc, s) => {
        let svcInv = s.Invoices.map((item) => {
          const formattedDate = formatDateYYYYMMDD(item.workOrderSvcDate);
          const urlDate = formatDateDelmtrYYYYMMDD(formattedDate, "/");
          const invoiceNumber = item.invoiceNum;
          const invoiceAmount = amountFormatter(item.invoiceAmount);
          const invAmtIntPart = Globals.currencySymbol + invoiceAmount.dollars;
          const invAmtFractPart = invoiceAmount.cents;
          const invoiceOpen = item.invoiceOpen;
          const dateMMDDYYYY = formatDateMMDDYYYY(item.workOrderSvcDate);
          const invoiceDate = formatDateMMDDYYYY(item.invoiceDate);
          const encryptedWONo = customerNumber && item.workOrderRef ? encryptData(item.workOrderRef + `__documentvalue${Date.now()}`, "serviceWorkOrder") : "";

          return {
            urlDate,
            invoiceOpen,
            invAmtIntPart,
            invAmtFractPart,
            invoiceNumber,
            invoiceAmount,
            desc: item.svcDescription,
            date: dateMMDDYYYY,
            invoiceDate,
            link: "#",
            ticketLink: customerNumber && item.workOrderRef ? `${process.env.REACT_APP_CMS_URL}/document/commercial/${formatedCustomerNumber}/workordernumber/${encryptedWONo}` : ''
          };
        });
        svcInv.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        return [...acc, ...svcInv];
      }, []);

      const dataServices = salesagr.reduce((acc, s) => {
        let svcInv = s.Invoices.map((item) => {
          const formattedDate = formatDateYYYYMMDD(item.workOrderSvcDate);
          const urlDate = formatDateDelmtrYYYYMMDD(formattedDate, "/");
          const invoiceNumber = item.invoiceNum;
          const dateMMDDYYYY = formatDateMMDDYYYY(item.workOrderSvcDate);
          const encryptedWONo = customerNumber && item.workOrderRef ? encryptData(item.workOrderRef + `__documentvalue${Date.now()}`, "serviceWorkOrder") : "";
          
          return {
            invoiceNumber,
            desc: item.svcDescription,
            date: dateMMDDYYYY,
            link: customerNumber && item.workOrderRef ? `${process.env.REACT_APP_CMS_URL}/document/commercial/${formatedCustomerNumber}/workordernumber/${encryptedWONo}` : ''
          };
        });
        svcInv.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
        return [...acc, ...svcInv];
      }, []);

      setYears(invoiceYears);
      setSelectedYear(invoiceYears[0]);
      setDataInvoices(dataInvoices);
      setDataServices(dataServices);
    } else if (response?.status === 401) {
      // Flag unauthorized → handle in effect below
      setUnauthorizeResponse(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setCustomerSummary(customerSummaryInfo);
  }, [customerSummaryInfo]);

  useEffect(() => {

    setErrMsg("");

    if (!IsLoggedIn() || unauthorizeResponse) {
      Storage.logoutUser();
      localStorage.clear();
      navigate("/login", { replace: true });
    }
    let [serviceAddress, customerNumber] = ["", custNumbers[0]];
    if (selectedServiceAddress != null) {
      [serviceAddress, customerNumber] = selectedServiceAddress.split(" | ");
    }
    const bypassCacheHeaderValue = bypassCache === "true" ? newTimeStampValue : store.getState().accountSummary.accountDetailsCacheTimeStampValue;

    (async () => {
      if(!allCustomersApiCalled)
        setIsLoading(true);
      if (customerNumber !== custNo) {
        await getCustomerSummary(customerNumber);
        setCustNo(customerNumber);
        if(allCustomersApiCalled)
          await fetchAccountDetails(customerNumber, serviceAddress, bypassCacheHeaderValue);
      }
      else if (customerSummary == null) {
        await getCustomerSummary(custNumbers[0]);

        let [serviceAddress, customerNumber] = $(`#serviceAddressSelect`)?.val()?.split(" | ");
        if(allCustomersApiCalled)
          await fetchAccountDetails(customerNumber, serviceAddress, bypassCacheHeaderValue);
      }
      else if (customerSummary != null) {
        if(allCustomersApiCalled)
          await fetchAccountDetails(customerNumber, serviceAddress, bypassCacheHeaderValue);
      }
    })();

    return () => {
      setErrMsg("");
      setIsLoading(true);
    }
  }, [unauthorizeResponse, selectedServiceAddress, allCustomersApiCalled]);

  
  const handleChangeYear = (e) => {
    setSelectedYear(e.target.value);
  };

  return (
    <>
      {errMsg == "" && isLoading && <Loader />}
      {errMsg != "" && <ErrorBlock errMsg={errMsg} />}

      {errMsg == "" && !isLoading && selectedYear ? (
        <div className={styles["tru-mma-main-wrapper"]}>
          <div className=" tg-mydoc-border">
            <div className="row justify-content-md-end">
              <div className="col-6 col-md-4 col-lg-2">
                <Dropdown
                  className={styles["custom-select"]}
                  options={years}
                  onChange={handleChangeYear}
                  value={selectedYear}
                />
              </div>
            </div>
            <DocumentWrapper
              labels={labels}
              year={selectedYear}
              heading={labels.serviceSummaries}
              headers={headers}
              targetValue={labels.targetSummaries}
              headingText={MY_DOCUMENTS.SERVICE}
              linkText={labels.viewTicket}
              data={dataServices}
            />
            <DocumentWrapper
              labels={labels}
              year={selectedYear}
              heading={labels.invoices}
              headers={headers}
              targetValue={labels.targetInvoices}
              headingText={MY_DOCUMENTS.INVOICE}
              linkText={labels.viewInvoice}
              data={dataInvoices}
            />
            
          </div>
        </div>
      ) : null}
    </>
  );
};

export default MyDocuments;
